import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f3539f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rooms-details-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editing this will change this room's code. This change will prevent any users from using the current room code and will invalidate any apps users currently may have open. Are you sure you want to edit the room code?", -1))
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { class: "d-flex justify-content-between row g-0" }
const _hoisted_5 = {
  class: "col text-wrap text-truncate",
  "data-test": "room-details-heading"
}
const _hoisted_6 = { class: "col-auto ms-auto align-self-end align-self-sm-start me-sm-2" }
const _hoisted_7 = { class: "mt-sm-0 d-flex col-sm-auto mt-2 col-12 col-sm-auto" }
const _hoisted_8 = {
  key: 0,
  class: "mb-2 mb-sm-0 me-sm-2"
}
const _hoisted_9 = { class: "ms-auto" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create this room to finish.", -1))
const _hoisted_11 = {
  key: 2,
  class: "onboarding__target onboarding__target--top-left"
}
const _hoisted_12 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-name-caption " }, "Enter a room name. Example: Downstairs Conference Room", -1))
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-code-heading" }, "Refresh to generate or click to edit. (25 character limit with letters or numbers)", -1))
const _hoisted_18 = ["d"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("You must link a "),
  /*#__PURE__*/_createElementVNode("strong", null, "room"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", null, "receiver"),
  /*#__PURE__*/_createTextVNode(" to complete setup.")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-add-receiver-caption" }, "Select an available receiver to link to this Room. You can link multiple Ditto Receivers to a Room.", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Locations"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", null, "Room Groups"),
  /*#__PURE__*/_createTextVNode(" offer another layer of organization. These fields are optional.")
], -1))
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-location-caption" }, "Add this room to a location for easier management.", -1))
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-groups-caption" }, "Add this room to a group for easier management.", -1))
const _hoisted_27 = {
  key: 0,
  class: "row"
}
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-download-background-caption" }, "Download a custom background with connection information for this room, and set it as the desktop or screensaver of the receiver for end users.", -1))
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-download-sign-caption" }, "Print a custom sign with connection information for this room, and display it for end-users.", -1))
const _hoisted_32 = {
  key: 1,
  class: "row"
}
const _hoisted_33 = { class: "col-sm-12" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-locally-host-apps-text" }, "Locally Host Apps", -1))
const _hoisted_35 = {
  key: 0,
  "data-test": "room-details-locally-host-apps-caption"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You can save bandwidth for your organization by hosting the Ditto Connect apps for Mac and Windows on an intranet or other web server. Download the Ditto Connect apps for Mac and Windows, upload them to your web server and provide the absolute HTTPS URLs for each platform below.", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note:"),
  /*#__PURE__*/_createTextVNode(" If you choose this option, you must download the Ditto Connect apps and re-upload them to your server periodically because Ditto Connect apps hosted on local servers expire every 30 days. Contact Ditto support to learn more.")
], -1))
const _hoisted_38 = ["href"]
const _hoisted_39 = ["href"]
const _hoisted_40 = ["href"]
const _hoisted_41 = {
  key: 2,
  "data-test": "room-details-mirroring-and-signage-settings-heading"
}
const _hoisted_42 = {
  key: 3,
  class: "row"
}
const _hoisted_43 = { class: "col-sm-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-mirroring-text" }, "Enable Mirroring", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-mirroring-caption" }, "Enable screen mirroring in this room.", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-native-resolution-text" }, "Enable Native Resolution", -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label_warning align-middle" }, "Overrides organization setting", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-native-resolution-caption" }, "Enable sending native resolution of Windows and Mac devices to the receiver. If this setting is disabled, all devices are scaled down to 1920x1080 pixels.", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-show-connection-info-text" }, "Always Show Connection Info", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-show-connection-info-caption" }, "Room code will be visible while a user is mirroring or when signage is displayed.", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-show-date-on-signage-text" }, "Always Show Date and Time on Signage", -1))
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label_warning align-middle" }, "Overrides organization setting", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-show-date-on-signage-caption" }, "Date and time will be visible when signage is displayed.", -1))
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label_warning align-middle" }, "Overrides organization location setting", -1))
const _hoisted_58 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-signage-text" }, "Enable Signage", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-signage-caption" }, "Enable digital signage in this room.", -1))
const _hoisted_61 = {
  key: 4,
  class: "row"
}
const _hoisted_62 = { class: "col-sm-6" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "room-details": "room-details-enable-alerts-text" }, "Enable Ditto Alerts", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-alerts-caption" }, "Allow emergency and other alert types such as custom alerts and CAP notifications to be shown in this room.", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, null, -1))
const _hoisted_66 = {
  key: 5,
  "data-test": "room-details-moderator-settings-heading"
}
const _hoisted_67 = {
  key: 6,
  class: "row"
}
const _hoisted_68 = { class: "col-sm-6" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-moderator-text" }, "Enable Moderator Controls", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-enable-moderator-caption" }, [
  /*#__PURE__*/_createTextVNode("Enable Ditto Director in this room. Use the Ditto Director app to moderate mirrored devices. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.airsquirrels.com/ditto/director/source/portal",
    target: "_blank",
    rel: "noreferrer noopener",
    class: "primary-color",
    "data-test": "room-details-enable-moderator-learn-more-link"
  }, "Learn more"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "One-time onscreen code:"),
  /*#__PURE__*/_createTextVNode(" Ditto Director users must enter a random code the first time they connect in this room.")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Onscreen code:"),
  /*#__PURE__*/_createTextVNode(" Ditto Director users must enter a random code each time they connect in this room.")
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Custom password:"),
  /*#__PURE__*/_createTextVNode(" Ditto Director users must enter a custom password each time they connect in this room.")
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Receiver", -1))
const _hoisted_75 = {
  key: 0,
  class: "icon icon--large icon--danger ps-1",
  viewBox: "0 0 24 24"
}
const _hoisted_76 = ["d"]
const _hoisted_77 = {
  key: 0,
  class: "callout callout--danger mb-2"
}
const _hoisted_78 = {
  class: "icon icon--x-large icon--danger",
  viewBox: "0 0 24 24"
}
const _hoisted_79 = ["d"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The receivers in this room are using different security methods. Users may be prompted for multiple passwords or pins. For the best sharing experience, use the same security method for all receivers.", -1))
const _hoisted_81 = { class: "px-1" }
const _hoisted_82 = { class: "d-flex flex-row mb-3" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-receiver-ip-address-heading"
}, "IP Address: ", -1))
const _hoisted_84 = {
  class: "expanded-table__description",
  "data-test": "room-details-receiver-ip-address-value"
}
const _hoisted_85 = { class: "d-flex flex-row mb-3" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-receiver-mac-address-heading"
}, "MAC Address: ", -1))
const _hoisted_87 = {
  class: "expanded-table__description",
  "data-test": "room-details-receiver-mac-address-value"
}
const _hoisted_88 = { class: "d-flex flex-row mb-3" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-reciever-security-heading"
}, "Security: ", -1))
const _hoisted_90 = { class: "expanded-table__description" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = {
  class: "icon icon--large icon--danger",
  viewBox: "0 0 24 24"
}
const _hoisted_93 = ["d"]
const _hoisted_94 = { class: "ps-1" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The receivers in this room are using different security methods. Users may be prompted for multiple passwords or pins. For the best sharing experience, use the same security method for all receivers.", -1))
const _hoisted_96 = { class: "d-flex flex-row mb-3" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-reciever-platform-heading"
}, "Platform: ", -1))
const _hoisted_98 = {
  class: "expanded-table__description",
  "data-test": "room-details-receiver-platform-value"
}
const _hoisted_99 = { class: "d-flex flex-row mb-3" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-receiver-version-heading"
}, "Version: ", -1))
const _hoisted_101 = {
  class: "expanded-table__description",
  "data-test": "room-details-receiver-version-value"
}
const _hoisted_102 = { class: "d-flex flex-row mb-3" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-status-heading"
}, "Status: ", -1))
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}, " Click here to learn more. ", -1))
const _hoisted_107 = {
  key: 0,
  "data-test": "room-details-receiver-status-text"
}
const _hoisted_108 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_109 = ["d"]
const _hoisted_110 = { class: "mt-4 mb-3 text-center" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-receiver-details-name-heading"
}, "Receiver Name", -1))
const _hoisted_112 = { class: "d-flex" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-receiver-details-platform-heading"
}, "Platform", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-receiver-details-version-heading"
}, "Version", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-receiver-details-status-heading"
}, "Status", -1))
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}, " Click here to learn more. ", -1))
const _hoisted_119 = {
  key: 0,
  "data-test": "room-details-receiver-status-text"
}
const _hoisted_120 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_121 = ["d"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-receiver-details-ip-address-heading"
}, "IP Address", -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-receiver-details-mac-address-heading"
}, "MAC Address", -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-receiver-details-security-heading"
}, "Security", -1))
const _hoisted_125 = {
  class: "icon icon--large icon--danger",
  viewBox: "0 0 24 24"
}
const _hoisted_126 = ["d"]
const _hoisted_127 = { class: "ps-1" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The receivers in this room are using different security methods. Users may be prompted for multiple passwords or pins. For the best sharing experience, use the same security method for all receivers.", -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-add-receiver-text" }, "Select an available receiver to link to this Room. You can link multiple Ditto Receivers to a Room.", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "room-details-add-receiver-caption" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note:"),
  /*#__PURE__*/_createTextVNode(" A legacy receiver cannot be linked with any other receivers, including other legacy receivers.")
], -1))
const _hoisted_132 = { class: "w-25" }
const _hoisted_133 = { class: "mb-2" }
const _hoisted_134 = { class: "px-1" }
const _hoisted_135 = { class: "d-flex flex-row mb-2" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-signage-rooms-heading"
}, "Rooms:", -1))
const _hoisted_137 = {
  class: "expanded-table__description ms-auto",
  "data-test": "room-details-signage-rooms-value"
}
const _hoisted_138 = { class: "d-flex flex-row mb-2" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-signage-items-heading"
}, "Signage Items:", -1))
const _hoisted_140 = {
  class: "expanded-table__description ms-auto",
  "data-test": "room-details-signage-items-value"
}
const _hoisted_141 = { class: "d-flex flex-row mb-2" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-details-signage-scheduled-heading"
}, "Scheduled:", -1))
const _hoisted_143 = {
  class: "expanded-table__description ms-auto",
  "data-test": "room-details-signage-scheduled-value"
}
const _hoisted_144 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { key: 1 }
const _hoisted_147 = { key: 2 }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, "⏱", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-signage-details-name-heading"
}, "Name", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-signage-details-rooms-heading"
}, "Rooms", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-signage-details-items-heading"
}, "Signage Items", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-signage-details-scheduled-heading"
}, "Scheduled", -1))
const _hoisted_153 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { key: 1 }
const _hoisted_156 = { key: 2 }
const _hoisted_157 = { key: 0 }
const _hoisted_158 = { key: 1 }
const _hoisted_159 = { key: 2 }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}, " Click here to learn more. ", -1))
const _hoisted_161 = {
  key: 0,
  "data-test": "room-details-receiver-status-text"
}
const _hoisted_162 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_163 = ["d"]
const _hoisted_164 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: "Customize Room Code",
      modelValue: _ctx.isRoomCodeWarningVisable,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isRoomCodeWarningVisable) = $event)),
      width: "40%",
      "before-close": _ctx.cancelRoomCodeWarning,
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _ctx.cancelRoomCodeWarning,
            "data-test": "room-details-edit-code-cancel-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _withModifiers(_ctx.confirmEditRoomCode, ["stop"]),
            "data-test": "room-details-edit-code-confirm-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Edit Code")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "primary-color",
          to: "/rooms",
          "data-test": "room-details-heading-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Rooms")
          ]),
          _: 1
        }),
        _createTextVNode(" » " + _toDisplayString(_ctx.room.roomName), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          onClick: _ctx.onCancel,
          "data-test": "room-details-cancel-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.creationMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                disabled: _ctx.saving,
                type: "danger",
                onClick: _ctx.onDelete,
                "data-test": "room-details-delete-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete Room")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_popover, {
            trigger: "manual",
            placement: "bottom-end",
            "popper-class": "onboarding__popover width-auto",
            visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.currentStep.value.banner && _ctx.userOnboardStatus.value.showDialog && !_ctx.onboardingDisable
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: _normalizeClass({ 'onboarding__above-overlay' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }),
                disabled: _ctx.saving || _ctx.onboardingDisable,
                type: "primary",
                onClick: _ctx.onSubmit,
                "data-test": `room-details-${_ctx.creationMode ? 'create' : 'save'}-button`
              }, {
                default: _withCtx(() => [
                  (_ctx.creationMode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Create Room")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Save Room")
                      ], 64)),
                  (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.room.roomName && _ctx.receiverToAdd.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class", "disabled", "onClick", "data-test"])
            ]),
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ])
    ]),
    (_ctx.showTierCallout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: _ctx.tierLimitReachedMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["dt-container dt-container--tabbed dt-flex", { 'onboarding__above-overlay' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }])
    }, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Overview",
            name: "overview"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "hide-required-asterisk": "",
                ref: "form",
                "label-position": "top",
                rules: _ctx.rules,
                model: _ctx.room,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_el_form_item, {
                        label: "Room Name",
                        prop: "roomName",
                        "data-test": "room-details-name-label"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.room.roomName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.room.roomName) = $event)),
                            class: _normalizeClass({ 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.currentStep.value.banner && _ctx.userOnboardStatus.value.showDialog && !_ctx.room.roomName}),
                            placeholder: "Room Name",
                            "data-test": "room-details-name-input"
                          }, null, 8, ["modelValue", "class"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (!_ctx.creationMode)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Customize Room Code",
                            prop: "roomCode"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17,
                              _createVNode(_component_el_input, {
                                disabled: _ctx.saving,
                                ref: "roomCodeInputField",
                                onClick: _ctx.showRoomCodeWarning,
                                onInput: _ctx.changeRoomCode,
                                modelValue: _ctx.roomCodeMutation,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.roomCodeMutation) = $event)),
                                "data-test": "room-details-code-input"
                              }, {
                                append: _withCtx(() => [
                                  (_openBlock(), _createElementBlock("svg", {
                                    class: "icon",
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.roomCodeRefreshHandler && _ctx.roomCodeRefreshHandler(...args))),
                                    viewBox: "0 0 24 24",
                                    "data-test": "room-details-code-refresh-button"
                                  }, [
                                    _createElementVNode("path", { d: _ctx.mdiRefresh }, null, 8, _hoisted_18)
                                  ]))
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick", "onInput", "modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_popover, {
                            key: 1,
                            trigger: "manual",
                            placement: "bottom-end",
                            "popper-class": "onboarding__popover width-auto",
                            disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded || !_ctx.creationMode,
                            visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.currentStep.value.banner && _ctx.userOnboardStatus.value.showDialog && !_ctx.receiverToAdd.id
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "Add Receiver",
                                "data-test": "room-details-add-receiver-label"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_20,
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.canAddReceivers,
                                    effect: "dark",
                                    content: _ctx.tierLimitReachedMessage,
                                    placement: "bottom-start",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        clearable: "",
                                        modelValue: _ctx.receiverToAdd,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receiverToAdd) = $event)),
                                        "value-key": "id",
                                        class: _normalizeClass({ 'el-input el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.currentStep.value.banner && _ctx.userOnboardStatus.value.showDialog && !_ctx.receiverToAdd.id }),
                                        placeholder: _ctx.noReceiversAvailablePlaceholder,
                                        disabled: _ctx.noReceiversAvailable || !_ctx.canAddReceivers,
                                        style: {"width":"100%"},
                                        "data-test": "room-details-receivers-dropdown"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableReceivers, (receiver) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: receiver.id,
                                              label: receiver.displayName,
                                              value: receiver
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(receiver.displayName), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "class", "placeholder", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "content"])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }, 8, ["disabled", "visible"]))
                    ])
                  ]),
                  _createVNode(_component_el_popover, {
                    trigger: "manual",
                    placement: "bottom",
                    "popper-class": "onboarding__popover",
                    width: 300,
                    offset: 30,
                    disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded || !_ctx.creationMode,
                    visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.currentStep.value.banner && _ctx.userOnboardStatus.value.showDialog
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_el_form_item, {
                            label: "Location",
                            class: _normalizeClass({ 'mb-0': _ctx.creationMode }),
                            "data-test": "room-details-location-label"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createVNode(_component_el_select, {
                                disabled: _ctx.saving || _ctx.noLocationsAvailable,
                                clearable: "",
                                filterable: "",
                                modelValue: _ctx.room.location,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.room.location) = $event)),
                                placeholder: _ctx.noLocationsAvailablePlaceholder,
                                "value-key": "id",
                                onClear: _cache[6] || (_cache[6] = ($event: any) => (_ctx.room.location = null)),
                                "data-test": "room-details-locations-dropdown"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLocations, (location) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: location.id,
                                      label: location.name,
                                      value: location
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(location.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled", "modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_el_form_item, {
                            label: "Room Groups",
                            class: _normalizeClass({ 'mb-0': _ctx.creationMode }),
                            "data-test": "room-details-groups-heading"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26,
                              _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                                disabled: _ctx.saving,
                                modelValue: _ctx.room.groups,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.room.groups) = $event)),
                                multiple: "",
                                "no-data-text": "No groups have been created",
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                loading: _ctx.groupsApiLoadingx,
                                "loading-text": "Creating room group...",
                                "value-key": "id",
                                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectHandler($event, _ctx.a))),
                                placeholder: "Select or Search Room Groups",
                                "data-test": "room-details-groups-dropdown"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroups, (group, i) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: i,
                                      label: group.name,
                                      value: group
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled", "modelValue", "loading"])), [
                                [_directive_loading, _ctx.groupsApiLoading]
                              ])
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["disabled", "visible"]),
                  (!_ctx.creationMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_el_form_item, {
                            label: "Download Room Background",
                            "data-test": "room-details-download-background-heading"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29,
                              _createVNode(_component_router_link, {
                                to: { path: `/rooms/background/${ _ctx.room.id }`},
                                target: "_blank",
                                rel: "noreferrer noopener"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    disabled: _ctx.saving,
                                    type: "primary",
                                    plain: "",
                                    "data-test": "room-details-download-background-button"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Download Room Background")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_el_form_item, {
                            label: "Download Room Sign",
                            "data-test": "room-details-download-sign-heading"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_31,
                              _createVNode(_component_router_link, {
                                to: { path: `/rooms/instructions/${ _ctx.room.id }` },
                                target: "_blank",
                                rel: "noreferrer noopener"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    disabled: _ctx.saving,
                                    type: "primary",
                                    plain: "",
                                    "data-test": "room-details-download-sign-button"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Download Room Sign")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.creationMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("label", null, [
                                _createVNode(_component_el_switch, {
                                  modelValue: _ctx.room.useLocalBinaries,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.room.useLocalBinaries) = $event)),
                                  disabled: _ctx.isTrial,
                                  "data-test": "room-details-locally-host-apps-switch"
                                }, null, 8, ["modelValue", "disabled"]),
                                _hoisted_34
                              ]),
                              (_ctx.isTrial)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Subscribe to a Ditto plan to save bandwidth for your organization by hosting the pre-configured Ditto apps on an intranet or other web server."))
                                : _createCommentVNode("", true),
                              (_ctx.room.useLocalBinaries)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_36,
                                    _hoisted_37,
                                    _createElementVNode("span", null, [
                                      _createTextVNode("Download Apps: "),
                                      _createElementVNode("a", {
                                        class: "blue",
                                        href: _ctx.room.win32_binary
                                      }, "Win 32", 8, _hoisted_38),
                                      _createTextVNode(" | "),
                                      _createElementVNode("a", {
                                        class: "blue",
                                        href: _ctx.room.win64_binary
                                      }, "Win 64", 8, _hoisted_39),
                                      _createTextVNode(" | "),
                                      _createElementVNode("a", {
                                        class: "blue",
                                        href: _ctx.room.macOS_binary
                                      }, "macOS", 8, _hoisted_40)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.creationMode)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_41, "Mirroring & Signage Settings"))
                    : _createCommentVNode("", true),
                  (!_ctx.creationMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("label", null, [
                                _createVNode(_component_el_switch, {
                                  modelValue: _ctx.room.enableMirroring,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.room.enableMirroring) = $event)),
                                  "data-test": "room-details-enable-mirroring-switch"
                                }, null, 8, ["modelValue"]),
                                _hoisted_44
                              ]),
                              _hoisted_45
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("label", null, [
                                _createVNode(_component_el_switch, {
                                  modelValue: _ctx.enableHigherResolutionSetting,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.enableHigherResolutionSetting) = $event)),
                                  "data-test": "room-details-enable-native-resolution-switch"
                                }, null, 8, ["modelValue"]),
                                _hoisted_46,
                                _createTextVNode(),
                                (_ctx.enableHigherResolutionSetting != _ctx.organization.enableHigherResolution)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _createVNode(_component_Icon, {
                                        class: "icon--danger icon--small ms-2 me-1 align-middle",
                                        icon: _ctx.mdiAlertCircleOutline
                                      }, null, 8, ["icon"]),
                                      _hoisted_48
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_49
                            ]),
                            _: 1
                          }),
                          (_ctx.hasSSPReceiver && _ctx.showConnectionInfo)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                class: _normalizeClass({'mb-0' : _ctx.room.showConnectionInfo})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", null, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.room.showConnectionInfo,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.room.showConnectionInfo) = $event)),
                                      "data-test": "room-details-show-connection-info-switch"
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_50
                                  ]),
                                  _hoisted_51
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.hasSSPReceiver && _ctx.showConnectionInfo)
                            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                                default: _withCtx(() => [
                                  (_ctx.room.showConnectionInfo)
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 0,
                                        modelValue: _ctx.room.connectionInfoPosition,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.room.connectionInfoPosition) = $event)),
                                        "data-test": "room-details-show-connection-info-dropdown"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "Top Left",
                                            value: "topLeft"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Top Right",
                                            value: "topRight"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Bottom Left",
                                            value: "bottomLeft"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Bottom Right",
                                            value: "bottomRight"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.hasSSPReceiver)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                class: _normalizeClass({'mb-0' : _ctx.showSignageDateTimeSetting})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", null, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.showSignageDateTimeSetting,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showSignageDateTimeSetting) = $event)),
                                      "data-test": "room-details-show-date-on-signage-switch"
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_52,
                                    (_ctx.showSignageDateTimeSetting != _ctx.organization.showSignageDateTime)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                          _createVNode(_component_Icon, {
                                            class: "icon--danger icon--small ms-2 me-1 align-middle",
                                            icon: _ctx.mdiAlertCircleOutline
                                          }, null, 8, ["icon"]),
                                          _hoisted_54
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _hoisted_55
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.hasSSPReceiver && _ctx.showSignageDateTimeSetting)
                            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 3 }, {
                                default: _withCtx(() => [
                                  (_ctx.showSignageDateTimeSetting)
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 0,
                                        modelValue: _ctx.signageDateTimeLocationSetting,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.signageDateTimeLocationSetting) = $event)),
                                        "data-test": "room-details-show-date-on-signage-dropdown"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "Top Left",
                                            value: "topLeft"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Top Right",
                                            value: "topRight"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Bottom Left",
                                            value: "bottomLeft"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Bottom Right",
                                            value: "bottomRight"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.signageDateTimeLocationSetting != _ctx.organization.signageDateTimeLocation)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                        _createVNode(_component_Icon, {
                                          class: "icon--danger icon--small ms-2 me-1 align-middle",
                                          icon: _ctx.mdiAlertCircleOutline
                                        }, null, 8, ["icon"]),
                                        _hoisted_57
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasSSPReceiver)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.hasSignage,
                                    effect: "dark",
                                    content: _ctx.upgradeText,
                                    placement: "bottom",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("label", null, [
                                        _createVNode(_component_el_switch, {
                                          disabled: !_ctx.hasSignage,
                                          modelValue: _ctx.room.enableSignage,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.room.enableSignage) = $event)),
                                          "data-test": "room-details-enable-signage-switch"
                                        }, null, 8, ["disabled", "modelValue"]),
                                        _hoisted_59
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "content"]),
                                  _hoisted_60
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.creationMode && _ctx.hasSSPReceiver)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tooltip, {
                                disabled: _ctx.hasAlerts,
                                effect: "dark",
                                content: _ctx.upgradeText,
                                placement: "bottom",
                                "hide-after": 0,
                                "show-after": 500
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", null, [
                                    _createVNode(_component_el_switch, {
                                      disabled: !_ctx.hasAlerts,
                                      modelValue: _ctx.room.enableAlerts,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.room.enableAlerts) = $event)),
                                      "data-test": "room-details-enable-alerts-switch"
                                    }, null, 8, ["disabled", "modelValue"]),
                                    _hoisted_63
                                  ])
                                ]),
                                _: 1
                              }, 8, ["disabled", "content"]),
                              _hoisted_64
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_65
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.creationMode && _ctx.hasSSPReceiver)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_66, "Moderator Settings"))
                    : _createCommentVNode("", true),
                  (!_ctx.creationMode && _ctx.hasSSPReceiver)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tooltip, {
                                disabled: _ctx.hasModeratorControls,
                                effect: "dark",
                                content: _ctx.upgradeText,
                                placement: "bottom",
                                "hide-after": 0,
                                "show-after": 500
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", null, [
                                    _createVNode(_component_el_switch, {
                                      disabled: !_ctx.hasModeratorControls,
                                      modelValue: _ctx.room.enableModeratorControls,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.room.enableModeratorControls) = $event)),
                                      onChange: _ctx.checkEnableModeratorControls,
                                      "data-test": "room-details-enable-moderator-control-switch"
                                    }, null, 8, ["disabled", "modelValue", "onChange"]),
                                    _hoisted_69
                                  ])
                                ]),
                                _: 1
                              }, 8, ["disabled", "content"]),
                              _hoisted_70
                            ]),
                            _: 1
                          }),
                          (_ctx.room.enableModeratorControls)
                            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                default: _withCtx(() => [
                                  _hoisted_71,
                                  _hoisted_72,
                                  _hoisted_73,
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.hasModeratorControls,
                                    effect: "dark",
                                    content: _ctx.upgradeText,
                                    placement: "bottom",
                                    "hide-after": 0,
                                    "show-after": 500
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        disabled: !_ctx.hasModeratorControls,
                                        modelValue: _ctx.room.moderatorConnectionType,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.room.moderatorConnectionType) = $event)),
                                        onChange: _ctx.checkModeratorType,
                                        "data-test": "room-details-moderator-control-dropdown"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "One-time onscreen code",
                                            value: "onScreenOneTime"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Onscreen code",
                                            value: "onScreen"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Custom password",
                                            value: "password"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "content"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.room.enableModeratorControls && _ctx.room.moderatorConnectionType == 'password')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                prop: "moderatorPassword"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.room.moderatorPassword,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.room.moderatorPassword) = $event)),
                                    placeholder: "Type Password",
                                    "data-test": "room-details-moderator-password-input"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ]),
            _: 1
          }),
          (!_ctx.creationMode)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                name: "receiver"
              }, {
                label: _withCtx(() => [
                  _hoisted_74,
                  (_ctx.showSecurityWarning)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_75, [
                        _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_76)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  (_ctx.showSecurityWarning)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_78, [
                          _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_79)
                        ])),
                        _hoisted_80
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.receiversDisplay,
                    ref: "roomReceiversTable",
                    onCellClick: _ctx.handleCurrentChange,
                    onSortChange: _ctx.handleReceiverSortChange
                  }, {
                    default: _withCtx(() => [
                      (_ctx.windowWidth.value < 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            type: "expand",
                            width: "55"
                          }, {
                            default: _withCtx((props) => [
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _hoisted_83,
                                  _createElementVNode("div", _hoisted_84, _toDisplayString(props.row.manualIpAddressOverride ? props.row.lastKnownIpAddress : props.row.manualIpAddresses[0]), 1)
                                ]),
                                _createElementVNode("div", _hoisted_85, [
                                  _hoisted_86,
                                  _createElementVNode("div", _hoisted_87, _toDisplayString(props.row.identifiers.mac), 1)
                                ]),
                                _createElementVNode("div", _hoisted_88, [
                                  _hoisted_89,
                                  _createElementVNode("div", _hoisted_90, [
                                    (_ctx.showSecurityWarning)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                          (_openBlock(), _createElementBlock("svg", _hoisted_92, [
                                            _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_93)
                                          ])),
                                          _createVNode(_component_el_tooltip, {
                                            placement: "top-start",
                                            "show-after": "500",
                                            "popper-class": "tooltip-width"
                                          }, {
                                            content: _withCtx(() => [
                                              _hoisted_95
                                            ]),
                                            default: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_94, _toDisplayString(props.row.security), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(props.row.security), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_96, [
                                  _hoisted_97,
                                  _createElementVNode("div", _hoisted_98, _toDisplayString(props.row.platform), 1)
                                ]),
                                _createElementVNode("div", _hoisted_99, [
                                  _hoisted_100,
                                  _createElementVNode("div", _hoisted_101, _toDisplayString(props.row.lastKnownVersion), 1)
                                ]),
                                _createElementVNode("div", _hoisted_102, [
                                  _hoisted_103,
                                  _createVNode(_component_el_popover, {
                                    "popper-class": "is-dark",
                                    trigger: "click",
                                    placement: "top-start",
                                    width: 300
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.receiverStatus(props.row.status).toLowerCase()}`)
                                      }, [
                                        (_ctx.receiverStatus(props.row.status).toLowerCase() != 'legacy')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(_ctx.receiverStatus(props.row.status)), 1))
                                          : (_openBlock(), _createElementBlock("svg", _hoisted_108, [
                                              _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_109)
                                            ]))
                                      ], 2)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, [
                                        (_ctx.receiverStatus(props.row.status).toLowerCase() != 'legacy')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_104, "Receiver status is " + _toDisplayString(_ctx.receiverStatus(props.row.status).toLowerCase()) + ". ", 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_105, "Legacy receivers do not support receiver status. ")),
                                        _hoisted_106
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_110, [
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    onClick: ($event: any) => (_ctx.removeReceiverHandler(props.row)),
                                    plain: "",
                                    round: "",
                                    id: props.row.id,
                                    "data-test": "room-details-receiver-remove-button"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Remove Receiver ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "id"])
                                ])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_table_column, {
                        prop: "displayName",
                        label: "Receiver Name",
                        sortable: "custom"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_111
                        ]),
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_112, [
                            _createVNode(_component_router_link, {
                              class: "el-table-column__name me-2 me-sm-0",
                              to: `/receivers/${scope.row.id}`,
                              "data-test": "room-details-receiver-name-value"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.displayName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            (_ctx.windowWidth.value < 576)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(`ms-auto align-self-center receiver-status__badge__mobile receiver-status__badge__mobile--${_ctx.receiverStatus(scope.row.status).toLowerCase()}`),
                                  "aria-hidden": "true"
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 1,
                            prop: "platform",
                            label: "Platform",
                            sortable: "custom"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_113
                            ]),
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.platform) + " (" + _toDisplayString(scope.row.deviceType) + ") ", 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 2,
                            prop: "lastKnownVersion",
                            label: "Version",
                            sortable: "custom"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_114
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 3,
                            prop: "status",
                            label: "Status",
                            sortable: "custom"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_115
                            ]),
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_popover, {
                                "popper-class": "is-dark",
                                trigger: "hover",
                                placement: "top-start",
                                width: 300
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.receiverStatus(scope.row.status).toLowerCase()}`)
                                  }, [
                                    (_ctx.receiverStatus(scope.row.status).toLowerCase() != 'legacy')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_119, _toDisplayString(_ctx.receiverStatus(scope.row.status)), 1))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_120, [
                                          _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_121)
                                        ]))
                                  ], 2)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, [
                                    (_ctx.receiverStatus(scope.row.status).toLowerCase() != 'legacy')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_116, "Receiver status is " + _toDisplayString(_ctx.receiverStatus(scope.row.status).toLowerCase()) + ". ", 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_117, "Legacy receivers do not support receiver status. ")),
                                    _hoisted_118
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 4,
                            prop: "lastKnownIpAddress",
                            label: "IP Address",
                            sortable: "custom"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_122
                            ]),
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.manualIpAddressOverride ? scope.row.manualIpAddresses[0] : scope.row.lastKnownIpAddress), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 5,
                            prop: "macAddress",
                            label: "Mac Address",
                            sortable: "custom"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_123
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 6,
                            prop: "security",
                            label: "Security",
                            sortable: "custom"
                          }, _createSlots({
                            header: _withCtx(() => [
                              _hoisted_124
                            ]),
                            _: 2
                          }, [
                            (_ctx.showSecurityWarning)
                              ? {
                                  name: "default",
                                  fn: _withCtx((scope) => [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_125, [
                                      _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_126)
                                    ])),
                                    _createVNode(_component_el_tooltip, {
                                      placement: "top-start",
                                      "show-after": "500",
                                      "popper-class": "tooltip-width"
                                    }, {
                                      content: _withCtx(() => [
                                        _hoisted_128
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_127, _toDisplayString(scope.row.security), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1024))
                        : _createCommentVNode("", true),
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 7,
                            prop: "id"
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_button, {
                                type: "danger",
                                onClick: ($event: any) => (_ctx.removeReceiverHandler(scope.row)),
                                plain: "",
                                round: "",
                                id: scope.row.id,
                                "data-test": "room-details-receiver-remove-button"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Remove Receiver")
                                ]),
                                _: 2
                              }, 1032, ["onClick", "id"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data", "onCellClick", "onSortChange"])), [
                    [_vShow, _ctx.receiversDisplay],
                    [_directive_loading, _ctx.receiverTableLoading]
                  ]),
                  _hoisted_129,
                  (!(_ctx.receivers && _ctx.receivers.length > 0) || _ctx.hasSSPReceiver)
                    ? (_openBlock(), _createBlock(_component_el_form, {
                        key: 1,
                        ref: "addReceiverForm",
                        "label-position": "top",
                        "label-width": "120px",
                        class: "row"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "Add Receiver",
                            class: "col-sm-6",
                            "data-test": "room-details-add-receiver-label"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_130,
                              _hoisted_131,
                              _createVNode(_component_el_select, {
                                disabled: _ctx.saving || _ctx.noReceiversAvailable,
                                style: {"width":"100%"},
                                modelValue: _ctx.receiverToAdd,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.receiverToAdd) = $event)),
                                "value-key": "id",
                                placeholder: _ctx.noReceiversAvailablePlaceholder,
                                "data-test": "room-details-add-receivers-dropdown"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableReceivers, (receiver) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: receiver.id,
                                      label: receiver.displayName,
                                      value: receiver
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(receiver.displayName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled", "modelValue", "placeholder"]),
                              _createElementVNode("span", _hoisted_132, [
                                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                  class: "mt-3",
                                  type: "primary",
                                  disabled: _ctx.saving,
                                  onClick: _ctx.addReceiversHandler,
                                  "data-test": "room-details-add-receiver-button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Add Receiver")
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"])), [
                                  [_directive_loading, _ctx.addReceiversApiLoading]
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.creationMode)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: "Signage",
                name: "signage"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_133, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.signageListsFilter,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.signageListsFilter) = $event)),
                        placeholder: "Filter signage lists",
                        clearable: "",
                        class: "signage__list-search my-auto",
                        "data-test": "room-details-signage-search-input"
                      }, {
                        prefix: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "signage__list-search-icon",
                            icon: _ctx.mdiMagnify
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_el_table, {
                      data: _ctx.filteredSignageLists,
                      onCellClick: _ctx.onRowClick,
                      onSortChange: _ctx.handleSignageSortChange,
                      sortable: "",
                      "empty-text": "No signage lists"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.windowWidth.value < 576)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              type: "expand",
                              width: "55"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_134, [
                                  _createElementVNode("div", _hoisted_135, [
                                    _hoisted_136,
                                    _createElementVNode("div", _hoisted_137, _toDisplayString(scope.row?.rooms?.length || 0), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_138, [
                                    _hoisted_139,
                                    _createElementVNode("div", _hoisted_140, [
                                      _createVNode(_component_router_link, {
                                        to: `/signage/${scope.row.id}#signage`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.row && scope.row.signageItems !== undefined ? (typeof scope.row.signageItems === 'number' ? scope.row.signageItems : scope.row.signageItems.length) : '0'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_141, [
                                    _hoisted_142,
                                    _createElementVNode("div", _hoisted_143, [
                                      _createElementVNode("span", null, _toDisplayString(scope.row.scheduledTimeSet ? 'Yes' : 'No'), 1),
                                      (scope.row.scheduledTimeSet)
                                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                            key: 0,
                                            "show-after": 200,
                                            placement: "bottom"
                                          }, {
                                            content: _withCtx(() => [
                                              _createElementVNode("ul", _hoisted_144, [
                                                (scope.row.isDateEnabled)
                                                  ? (_openBlock(), _createElementBlock("li", _hoisted_145, _toDisplayString(new Date(scope.row.startDate).toLocaleDateString()) + " - " + _toDisplayString(new Date(scope.row.endDate).toLocaleDateString()), 1))
                                                  : _createCommentVNode("", true),
                                                (scope.row.isTimeEnabled)
                                                  ? (_openBlock(), _createElementBlock("li", _hoisted_146, _toDisplayString(_ctx.convert24to12(scope.row.startTime)) + " - " + _toDisplayString(_ctx.convert24to12(scope.row.endTime)), 1))
                                                  : _createCommentVNode("", true),
                                                (scope.row.isDayEnabled)
                                                  ? (_openBlock(), _createElementBlock("li", _hoisted_147, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.activeDaysOfWeek.sort(_ctx.sortByDay), (day, i) => {
                                                        return (_openBlock(), _createElementBlock("span", { key: day }, [
                                                          _createTextVNode(_toDisplayString(day), 1),
                                                          (i < scope.row.activeDaysOfWeek.length - 1)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(", ")
                                                              ], 64))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      }), 128))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            default: _withCtx(() => [
                                              _hoisted_148
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_table_column, {
                          prop: "name",
                          label: "Name",
                          sortable: "",
                          "sort-method": _ctx.sortSignageListName
                        }, {
                          header: _withCtx(() => [
                            _hoisted_149
                          ]),
                          default: _withCtx((scope) => [
                            _createVNode(_component_router_link, {
                              to: `/signage/${scope.row.id}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 1
                        }, 8, ["sort-method"]),
                        (_ctx.windowWidth.value >= 576)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 1,
                              prop: "rooms",
                              label: "Rooms",
                              align: "center",
                              sortable: ""
                            }, {
                              header: _withCtx(() => [
                                _hoisted_150
                              ]),
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(scope.row?.rooms?.length || 0), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.windowWidth.value >= 576)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 2,
                              prop: "signageItems",
                              label: "Signage Items",
                              align: "center",
                              sortable: ""
                            }, {
                              header: _withCtx(() => [
                                _hoisted_151
                              ]),
                              default: _withCtx((scope) => [
                                _createVNode(_component_router_link, {
                                  to: `/signage/${scope.row.id}#signage`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row && scope.row.signageItems !== undefined ? (typeof scope.row.signageItems === 'number' ? scope.row.signageItems : scope.row.signageItems.length) : '0'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.windowWidth.value >= 576)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 3,
                              prop: "scheduledTimeSet",
                              label: "Scheduled",
                              align: "center",
                              sortable: ""
                            }, {
                              header: _withCtx(() => [
                                _hoisted_152
                              ]),
                              default: _withCtx((scope) => [
                                _createVNode(_component_el_tooltip, {
                                  disabled: !scope.row.scheduledTimeSet,
                                  "show-after": 200,
                                  placement: "bottom"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("ul", _hoisted_153, [
                                      (scope.row.isDateEnabled)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_154, _toDisplayString(new Date(scope.row.startDate).toLocaleDateString()) + " - " + _toDisplayString(new Date(scope.row.endDate).toLocaleDateString()), 1))
                                        : _createCommentVNode("", true),
                                      (scope.row.isTimeEnabled)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_155, _toDisplayString(_ctx.convert24to12(scope.row.startTime)) + " - " + _toDisplayString(_ctx.convert24to12(scope.row.endTime)), 1))
                                        : _createCommentVNode("", true),
                                      (scope.row.isDayEnabled)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_156, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.activeDaysOfWeek.sort(_ctx.sortByDay), (day, i) => {
                                              return (_openBlock(), _createElementBlock("span", { key: day }, [
                                                _createTextVNode(_toDisplayString(day), 1),
                                                (i < scope.row.activeDaysOfWeek.length - 1)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode(", ")
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(scope.row.scheduledTimeSet ? 'Yes' : 'No'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["disabled"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data", "onCellClick", "onSortChange"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.creationMode && _ctx.roomReceiverStatus)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 2,
                disabled: "true",
                name: "status"
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_el_popover, {
                    "popper-class": "is-dark",
                    trigger: _ctx.windowWidth.value >= 576 ? 'hover' : 'click',
                    placement: "bottom-start",
                    width: 300
                  }, {
                    reference: _withCtx(() => [
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.roomReceiverStatus.toLowerCase()}`),
                            "data-test": "room-details-status-heading"
                          }, [
                            ((_ctx.roomReceiverStatus.toLowerCase() === 'online') || (_ctx.roomReceiverStatus.toLowerCase() === 'offline'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_161, _toDisplayString(_ctx.roomReceiverStatus), 1))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_162, [
                                  (_ctx.roomReceiverStatus.toLowerCase() === 'warning')
                                    ? (_openBlock(), _createElementBlock("path", {
                                        key: 0,
                                        d: _ctx.mdiExclamationThick
                                      }, null, 8, _hoisted_163))
                                    : (_openBlock(), _createElementBlock("path", {
                                        key: 1,
                                        d: _ctx.mdiHelp
                                      }, null, 8, _hoisted_164))
                                ]))
                          ], 2))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(`ms-auto align-self-center receiver-status__badge__mobile receiver-status__badge__mobile--${_ctx.roomReceiverStatus.toLowerCase()}`),
                            "aria-hidden": "true"
                          }, null, 2))
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        ((_ctx.roomReceiverStatus.toLowerCase() === 'online') || (_ctx.roomReceiverStatus.toLowerCase() === 'offline'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_157, " The status for all receivers is " + _toDisplayString(_ctx.roomReceiverStatus.toLowerCase()) + ". ", 1))
                          : (_ctx.roomReceiverStatus.toLowerCase() === 'legacy')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_158, " Legacy receivers do not support receiver status. "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_159, "The status for 1 or more receivers is not online. ")),
                        _hoisted_160
                      ])
                    ]),
                    _: 1
                  }, 8, ["trigger"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierDialog,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.showTierDialog) = $event)),
      isCallout: false,
      isLimit: true,
      message: _ctx.tierLimitReachedMessage
    }, null, 8, ["modelValue", "message"])
  ])), [
    [_directive_loading, _ctx.viewLoading]
  ])
}